import { useMsalConfig } from './use-msal-config.hook';
import { IB2COptions, IMsalProviderOptions } from '@vivli/core/infrastructure/interface';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';

export const useMsalOptions = () => {
    const config = useAppConfigContext();
    const msalConfig = useMsalConfig(config);

    //Detect a login from a partner set up as an SSO provider -
    //in the parnterLog the authorities configured
    //will use an SSO policy as an override policy for the sign-up/sign-in and default policies.
    //in the "normal login" case we will use the usual combined sign-up/sign-in and default policies.
    const isPartnerLogin = window.location.href.indexOf('partner-login') !== -1;
    const overridePolicyName = isPartnerLogin ? config?.b2CSSOPolicyName : null;

    const b2cOptions: IB2COptions = {
        scopes: [config?.b2CApiAccessScope, 'openid', 'profile'],
        tenant: config?.b2CTenant,
        authorities: {
            default: overridePolicyName || config?.b2CSignUpSignInPolicyName,
            signUpSignIn: overridePolicyName || config?.b2CSignUpSignInPolicyName,
            editProfile: config?.b2CEditProfilePolicyName,
            forgotPassword: config?.b2CPasswordPolicyName,
            sso: config?.b2CSSOPolicyName
        }
    };

    const options: IMsalProviderOptions = {
        b2cOptions,
        config: msalConfig
    };

    return {
        options,
        isPartnerLogin
    };
};
